import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import typing from "../../Assets/Projects/typing.jpg";
import cars from "../../Assets/Projects/cars.jpg";
import programming from "../../Assets/Projects/master-programming.jpg";
import  wedding from "../../Assets/Projects/wedding.jpg";
import brain from "../../Assets/Projects/creative-brain_1403664.jpg";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              id={1}
              imgPath={programming}
              isBlog={false}
              title="Master Programming"
              description="This is A Modern Platform For Learning Technology Like Html ,Css,Github,React"
              ghLink="https://github.com/lalon147/master-programming-project"
              demoLink="https://master-programming-e5574.firebaseapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
            id={2}
              imgPath={wedding}
              isBlog={false}
              title="Risan's Ceremony"
              description="It is Individual's service's review website ."
              ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              id={3}
              imgPath={cars}
              isBlog={false}
              title="Sekhanei Dot Com"
              description="It is an e-commerce platform for Buying and Selling Used or second hand cars"
              ghLink="https://github.com/lalon147/sekhanei-dot-com"
              demoLink="https://fir-auth-practice-9715f.firebaseapp.com/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              id={4}
              imgPath={typing}
              isBlog={false}
              title="Type Master"
              description="This is Platform For Practicing Typing Speed Of Some One It Helps User To Increase Typing Speed."
              ghLink="https://github.com/lalon147/typing-master"
              demoLink="https://lalon147.github.io/typing-master/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              id={5}
              imgPath={brain}
              isBlog={false}
              title="Creative brain"
              description="IT is a educational website for people who want to examine theirselves in Javascript,React,many more"
              ghLink="https://github.com/lalon147/creative-brain"
              demoLink="https://gilded-sunshine-9879f6.netlify.app/"
            />
          </Col>

          

          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
